export default __webpack_public_path__ + "static/media/EFERT.e8f3d95a.png";